import { Action, createReducer, on } from "@ngrx/store";
import { Claim } from "../../core/models/claim";
import { clearClaims, setClaims } from "./claim.actions";

export const featureKey = "claimStore";

export interface State {
  claims: Claim[];
}

const initalState: State = {
  claims: [],
};

const featureReducer = createReducer(
  initalState,
  on(clearClaims, (state, action): State => {
    return {
      claims: [],
    };
  }),
  on(setClaims, (state, action): State => {
    return {
      ...state,
      claims: action.claims,
    };
  })
);

export function reducer(state: State | undefined, action: Action) {
  return featureReducer(state, action);
}
